import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import CartList from './CartList';
import CartListV2 from './CartListV2';
import useExperiment from '../../hooks/useExperiment';
import useDevice, { devices } from '../../hooks/useDevice';
import { HIVEMIND_ON, HIVEMIND_OFF } from '../../../constants/hivemind';
import * as Metrics from '../utils/trackMetric';
import * as MetricEvents from '../../../constants/metrics';

function CartListWrapper(props) {
  const { olsProxyBaseUrl, viewDevice, shopHeader, ...rest } = props;

  const [device] = useDevice();
  const isMobile = device === devices.MOBILE || viewDevice === 'MOBILE_RENDER_DEVICE';

  const { bucket, isLoading } = useExperiment(
    `${olsProxyBaseUrl}/experiments/ols_mobile_cart_checkout_buttons_sticky_footer?isMobile=${isMobile}`
  );

  const { bucket: efficientCheckoutBucket, isLoading: isEfficientCheckoutLoading } = useExperiment(
    `${olsProxyBaseUrl}/experiments/ols_desktop_cart_efficient_checkout?isMobile=${isMobile}`
  );
  const shouldStickToBottom = bucket === HIVEMIND_ON;
  const shouldShowEfficientCheckout = efficientCheckoutBucket === HIVEMIND_ON;

  useEffect(() => {
    if (!shouldStickToBottom) return;

    let originalWidgetDisplay = 'block';
    let originalWidgetContainerDisplay = 'block';
    let widget = null;
    let widgetContainer = null;

    const hideWidgets = () => {
      widgetContainer = document.querySelector('.widget-messaging');
      widget = document.getElementById('reamaze-widget');

      if (widgetContainer && widget) {
        originalWidgetContainerDisplay = widgetContainer.style.display || 'block';
        originalWidgetDisplay = widget.style.display || 'block';
        widgetContainer.style.display = 'none';
        widget.style.display = 'none';
        return true;
      }

      return false;
    };

    const found = hideWidgets();
    if (found)
      return () => {
        widgetContainer.style.display = originalWidgetContainerDisplay;
        widget.style.display = originalWidgetDisplay;
      };

    const observer = new MutationObserver(() => {
      if (hideWidgets()) {
        observer.disconnect();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    return () => {
      observer.disconnect();
      if (widgetContainer) widgetContainer.style.display = originalWidgetContainerDisplay;
      if (widget) widget.style.display = originalWidgetDisplay;
    };
  }, [shouldStickToBottom]);

  useEffect(() => {
    if (isLoading) return;
    if (bucket === HIVEMIND_ON) {
      Metrics.track(MetricEvents.OLS_MOBILE_CART_CHECKOUT_BUTTONS_STICKY_FOOTER_ON_IMPRESSION);
    } else if (bucket === HIVEMIND_OFF) {
      Metrics.track(MetricEvents.OLS_MOBILE_CART_CHECKOUT_BUTTONS_STICKY_FOOTER_OFF_IMPRESSION);
    } else {
      Metrics.track(
        MetricEvents.OLS_MOBILE_CART_CHECKOUT_BUTTONS_STICKY_FOOTER_INELIGIBLE_IMPRESSION
      );
    }
  }, [bucket, isLoading]);

  useEffect(() => {
    if (isEfficientCheckoutLoading) return;
    if (efficientCheckoutBucket === HIVEMIND_ON) {
      Metrics.track(MetricEvents.OLS_CART_EFFICIENT_CHECKOUT_ON_IMPRESSION);
      const el = document.getElementById('ols-shop-container');
      el.style.minHeight = 'unset'; // Reset min-height to avoid layout issues
    } else if (efficientCheckoutBucket === HIVEMIND_OFF) {
      Metrics.track(MetricEvents.OLS_CART_EFFICIENT_CHECKOUT_OFF_IMPRESSION);
    } else {
      Metrics.track(MetricEvents.OLS_CART_EFFICIENT_CHECKOUT_INELIGIBLE_IMPRESSION);
    }
  }, [efficientCheckoutBucket, isEfficientCheckoutLoading]);

  if (!shouldShowEfficientCheckout) {
    return <CartList { ...rest } shouldStickToBottom={ shouldStickToBottom } />;
  }
  return <CartListV2 { ...rest } shopHeader={ shopHeader } />;
}

CartListWrapper.propTypes = {
  olsProxyBaseUrl: PropTypes.string.isRequired,
  viewDevice: PropTypes.string,
  shopHeader: PropTypes.object
};

export default CartListWrapper;
